<template lang="pug">
.settings-permissions
	page-header
		h1.highlight Manage your permissions
	page
		div.settings-permissions--info
			p Select the data you require for your application to work correctly from the options below. It is important to only select the data your application requires to comply with data protection legislation. 
			p If you have any questions relating to data permissions, or require further information, please create a support ticket.
		el-form.select-company-container(v-show="selectCompany", :inline='true')
			el-form-item(label='Select Company')
				company-search(v-model="companyId", @companiesFromSelection="setCompany")
		div(v-if="companyId")
			edit-company-scopes(:key="companyId", :companyId="companyId")
</template>

<script>
import EditCompanyScopes from "@/views/settings/includes/EditCompanyScopes";

export default {
	name: "ScopeSettings",
	components: {
		EditCompanyScopes
	},
	data: () => ({
		loading: true,
		companyId: undefined,
		selectCompany: false
	}),
	methods: {
		setCompany(companies) {
			if (companies.length > 1) this.selectCompany = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.settings-permissions {
	&--info {
		margin-bottom: 50px;
	}
}
</style>
